import { render } from "./NuevoTurno.vue?vue&type=template&id=6bf8e1ce&scoped=true&ts=true"
import script from "./NuevoTurno.vue?vue&type=script&lang=ts"
export * from "./NuevoTurno.vue?vue&type=script&lang=ts"

import "./NuevoTurno.vue?vue&type=style&index=0&id=6bf8e1ce&lang=scss"
import "./NuevoTurno.vue?vue&type=style&index=1&id=6bf8e1ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf8e1ce"]])

export default __exports__